import { Link } from "react-router-dom";
import { useEffect } from "react";
import Footer from "../components/Footer";
import AOS from "aos";
import "aos/dist/aos.css";

export default function Home() {
  const clients = [
    { name: "Panda Plates", image: null },
    // { name: "Panda Plates", image: "/images/clients/panda-plates-logo.png" },
    { name: "FC Lounge", image: null },
    // Add more clients here
  ];
  useEffect(() => {
    AOS.init({ once: true });
  }, []);

  return (
    <div className="min-h-screen flex flex-col">
      {/* Navbar */}
      <header className="bg-white shadow-md py-4 px-6 flex justify-between items-center sticky top-0 z-50">
        <h1 className="text-2xl font-bold text-indigo-600">Bill-Lex</h1>
        <div className="space-x-4">
          <Link to="/login" className="text-gray-600 hover:text-indigo-600">
            Login
          </Link>
          <Link
            to="/register"
            className="text-white bg-indigo-600 px-4 py-2 rounded hover:bg-indigo-700"
          >
            Get Started
          </Link>
        </div>
      </header>

      {/* Hero Section */}
      <main className="flex-1 flex flex-col justify-center items-center text-center px-4 py-20 bg-gradient-to-b from-indigo-50 to-white">
        <h2 className="text-4xl md:text-5xl font-bold mb-4" data-aos="fade-up">
          Smart Billing for Restaurants & Cloud Kitchens
        </h2>
        <p
          className="text-gray-600 mb-6 max-w-2xl"
          data-aos="fade-up"
          data-aos-delay="100"
        >
          Manage orders, generate bills, track inventory and view analytics –
          all from your phone or PC. Simplify your business with Bill-Lex.
        </p>
        <div className="space-x-4" data-aos="fade-up" data-aos-delay="200">
          <Link
            to="/register"
            className="bg-indigo-600 text-white px-6 py-3 rounded hover:bg-indigo-700"
          >
            Try Bill-Lex Free
          </Link>
          <Link
            to="/pricing"
            className="border border-indigo-600 text-indigo-600 px-6 py-3 rounded hover:bg-indigo-50"
          >
            View Pricing
          </Link>
        </div>
      </main>

      {/* Features Section */}
      <section className="py-16 bg-white text-center" id="features">
        <h3 className="text-3xl font-semibold mb-10" data-aos="fade-up">
          Powerful Features
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 px-6 max-w-6xl mx-auto">
          {[
            {
              title: "Billing & Invoicing",
              desc: "Easily generate professional bills for dine-in, takeaway, or delivery.",
            },
            {
              title: "Inventory Management",
              desc: "Track stock levels and get alerts before you run out.",
            },
            {
              title: "Daily Sales Reports",
              desc: "Visualize revenue, item performance, and customer trends.",
            },
            {
              title: "Multi-Device Access",
              desc: "Access your dashboard on any device, anywhere, anytime.",
            },
            {
              title: "User-Friendly Dashboard",
              desc: "A clean, intuitive interface for managing your restaurant business.",
            },
            {
              title: "Cloud Backup",
              desc: "Your data is securely stored and always available.",
            },
          ].map((feature, idx) => (
            <div
              key={idx}
              className="bg-indigo-50 p-6 rounded-lg shadow hover:shadow-lg transition"
              data-aos="fade-up"
              data-aos-delay={idx * 100}
            >
              <h4 className="text-xl font-bold mb-2 text-indigo-600">
                {feature.title}
              </h4>
              <p className="text-gray-700">{feature.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Clients Section */}
      <section className="py-16 bg-white text-center" data-aos="fade-up">
        <h3 className="text-2xl font-semibold mb-10">Trusted by Restaurants</h3>
        <div
          className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-6 px-6"
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
          }}
        >
          {clients.map((client, idx) => (
            <div key={idx} className="flex flex-col items-center text-center">
              {client.image ? (
                <img
                  src={client.image}
                  alt={client.name}
                  className="h-16 object-contain mb-2 transition-transform hover:scale-105"
                  onError={(e: any) => {
                    e.target.onerror = null;
                    e.target.src = "";
                    e.target.closest(
                      "div"
                    ).innerHTML = `<div class='bg-indigo-100 text-indigo-700 font-bold text-lg rounded px-4 py-6 w-full'>${client.name}</div>`;
                  }}
                />
              ) : (
                <div className="bg-indigo-100 text-indigo-700 font-bold text-lg rounded px-4 py-6 w-full">
                  {client.name}
                </div>
              )}
            </div>
          ))}
        </div>
      </section>

      {/* Pricing Section */}
      <section className="py-20 bg-gray-50 text-center" id="pricing">
        <h3 className="text-3xl font-semibold mb-10" data-aos="fade-up">
          Transparent & Affordable Pricing
        </h3>
        <div
          className="flex justify-center gap-10 flex-wrap px-4"
          data-aos="fade-up"
          data-aos-delay="100"
        >
          {/* Starter Plan */}
          <div className="bg-white shadow-md rounded-xl p-8 w-80 border">
            <h4 className="text-xl font-bold mb-2">Starter</h4>
            <p className="text-4xl font-semibold mb-4 text-indigo-600">₹0</p>
            <ul className="text-gray-600 mb-6 space-y-2 text-left">
              <li>✔ Up to 5 inventory items</li>
              <li>✔ Max 10 bills/day</li>
              <li>✖ No payment options</li>
              <li>✖ Limited analytics</li>
            </ul>
            <Link
              to="/register"
              className="bg-indigo-100 text-indigo-700 px-4 py-2 rounded hover:bg-indigo-200 inline-block"
            >
              Get Started
            </Link>
          </div>

          {/* Pro Plan */}
          <div className="bg-indigo-600 text-white shadow-xl rounded-xl p-8 w-80 border-2 border-indigo-700 transform hover:scale-105 transition">
            <h4 className="text-xl font-bold mb-2">Pro</h4>
            <p className="text-4xl font-semibold mb-4">₹359/mo</p>
            <ul className="mb-6 space-y-2 text-left">
              <li>✔ Unlimited inventory</li>
              <li>✔ Unlimited bills</li>
              <li>✔ Payment options enabled</li>
              <li>✔ Full analytics & reports</li>
              <li>✔ Priority support</li>
            </ul>
            <Link
              to="/register"
              className="bg-white text-indigo-700 px-4 py-2 rounded hover:bg-indigo-100 inline-block"
            >
              Start Free Trial
            </Link>
          </div>
        </div>
      </section>

      {/* Footer */}
      <Footer />
    </div>
  );
}
